<template>
  <div class="box">
    <div 
      id="tag-popup" 
      class="modal fade inactive" 
      data-backdrop="false">
      <div class="right w-xxxl white b-l">
        <vuetabletag_form
          :is-required-tag-input="false"
          :tag="tag"
          @showupProduct="showProduct($event)"
        />
      </div>
    </div>

    <div 
      id="product-popup" 
      class="modal fade inactive" 
      data-backdrop="true">
      <product_list 
        :tag="tag"
        :title="`${trans('tag.apply_tags_to_product')}`"
        @updateProduct="updateProduct($event)"
      />
    </div>

  </div>
</template>

<script>
import Auth from '@js/plugins/auth';

const exportUrl = 'franchise.inventory.tags.exportAsFile';

export default {
    data() {
        var that = this;
        let canManageItems = Auth.hasAnyPermission(
            'franchise_manage_items',
            'franchise_manage_tags',
        );

        let actionButtons = [
            {
                title: this.trans('tag.create_tag'),
                action: () => {
                    this.show_popup(null);
                },
            },
        ];

        if (!canManageItems) {
            actionButtons = [];
        }

        return {
            tag: {},
            products: {},
        };
    },

    created() {
        this.init_tag();
        this.removeLimitState();
        window.addEventListener('beforeunload', this.removeLimitState);
        this.registerEvent();
    },

    beforeDestroy() {
        this.$bus.$off('manage_tag::show_form');
    },

    methods: {
        init_tag(parent_id = null, type = null) {
            this.tag = {
                id: 0,
                name: '',
                code: null,
                parent_id: parent_id,
                description: '',
                products: [],
                modifier_sets: [],
                parent: null,
                hidden_tag: false,
                hidden_products: false,
                type: type,
            };
        },

        registerEvent() {
            this.$bus.$on('manage_tag::show_form', (data, type = null) => {
                this.show_popup(data, type);
            });
        },

        get_tag(id) {
            var that = this;
            this.$http.get(this.getTagApi(id)).then(response => {
                that.tag = response.data.data;
                that.show_modal();
            });
        },

        show_popup(row, type = null) {
            if (row != null && type == null) {
                this.get_tag(row.id);
            } else {
                let parent_id = type == 1 ? row.parent_id : row.id;
                this.init_tag(parent_id, type);
                this.show_modal();
            }
        },

        show_modal() {
            $('#tag-popup').modal('show');
        },

        showProduct(row) {
            this.data = row;
            this.show_product_modal();
        },

        show_product_modal() {
            $('#product-popup').modal('show');
        },

        updateProduct(row) {
            this.tag.products = row;
        },

        getTagApi(id) {
            return Laroute.route('franchise.inventory.tags.show', { id: id });
        },

        fetchData() {
            this.$refs.datatable.getData();
        },

        removeLimitState() {
            let query = JSON.parse(
                localStorage.getItem(`vuetables_${this.tableName}`),
            );

            if (!_.isNull(query) && !_.isUndefined(query.perPage)) {
                query.perPage = 20;

                localStorage.setItem(
                    `vuetables_${this.tableName}`,
                    JSON.stringify(query),
                );
            }
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/manage-tag.vue